<template>
  <div>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2.41895" :width="lineWidth" height="15.6743" :rx="lineWidth / 2" transform="rotate(-45 2 2.41895)" :fill="color"/>
      <rect :width="lineWidth" height="15.6743" :rx="lineWidth / 2"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.002 2.41895)" :fill="color"/>
    </svg>
  </div>
</template>

<script setup>
import {Props} from './scripts/props.js'

const props = defineProps(Props())

</script>

<style scoped lang="scss">
@import "./styles/style";
</style>
